import { isObjectOf, isOptionalOf, isString } from "../../utilities/typeGuardUtils";

export type ClientNotification = {
	uuid: string;
	title: string;
	message: string;
	level: "success" | "info" | "error" | "warning";
	/**
	 * Task key the process was in when the notification was created; absent on legacy notifications. The
	 * notification is written while that task is being left, so it is meant for the task that follows.
	 */
	addressee?: string;
};
export const isClientNotification = isObjectOf<ClientNotification>({
	uuid: isString,
	title: isString,
	message: isString,
	level: isString,
	addressee: isOptionalOf(isString)
});
